<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc"><h1>Contents</h1><ol><li id="level1-titlepage"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></li>
<li id="level1-toc"><a href="#/toc">Contents</a></li>
<li id="level1-front3"><a href="#/front01">Copyright</a></li>
<li id="level1-front4"><a href="#/front02">Dedication</a></li>
<li id="level1-front5"><a href="#/front03">Epigraph</a></li>
<li id="c01"><a href="#/c01">November</a>
</li>
<li id="c02"><span href="#/c02" title="Link target outside of Sample">December</span>
</li>
<li id="c03"><span href="#/c03" title="Link target outside of Sample">January</span>
</li>
<li id="level1-back12"><span href="#/back01" title="Link target outside of Sample">Acknowledgments</span></li>
<li id="level1-back13"><span href="#/back02" title="Link target outside of Sample">About the Author</span></li></ol></nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?7d9ecab2